__turbopack_context__.v({
  "buttonCard": "_1xLPZG_buttonCard",
  "card": "_1xLPZG_card",
  "cardWrapper": "_1xLPZG_cardWrapper",
  "content": "_1xLPZG_content",
  "date": "_1xLPZG_date",
  "iconContainer": "_1xLPZG_iconContainer",
  "interactiveCard": "_1xLPZG_interactiveCard",
  "interactiveCardWrapper": "_1xLPZG_interactiveCardWrapper" + " " + __turbopack_context__.i(248112)["focusKeyboardWithinOutline"],
  "textContent": "_1xLPZG_textContent",
});
